'use client';

import { useMemo, useState } from 'react';
import { Button } from '@/features/button';
import { IconArrowSquareDown, IconArrowSquareLeft, IconArrowSquareUp } from '@/features/icons';
import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import { PRODUCT_ATTRIBUTES_ROW_SHOW_LIMIT } from '@/app/(pdp)/constants';
import { PUBLIC_IS_BOT } from '@/app/_constants/search-engines';
import { cn } from '@/utils/cn';
import ProductAttributesTable from './product-attributes-table';
import usePDPData from '../../../_utils/use-pdp-data';
interface Props {
  openShowMoreModal: () => void;
}
function ProductAttributes({
  openShowMoreModal
}: Props) {
  const {
    isMobile
  } = useMobileDetect();
  const {
    data
  } = usePDPData();
  const attributes = useMemo(() => data?.attributes ?? [], [data?.attributes]);
  const [isShowFullList, setIsShowFullList] = useState(PUBLIC_IS_BOT);
  const handleClick = () => {
    if (isMobile) {
      openShowMoreModal();
      return;
    }
    setIsShowFullList(!isShowFullList);
  };
  const ShowMoreButtonIcon = useMemo(() => {
    if (isMobile) return IconArrowSquareLeft;
    if (isShowFullList) return IconArrowSquareUp;
    return IconArrowSquareDown;
  }, [isMobile, isShowFullList]);
  const showMoreButtonText = useMemo(() => {
    if (isMobile) return 'مشاهده مشخصات بیشتر';
    if (isShowFullList) return 'مشاهده کمتر';
    return 'مشاهده بیشتر';
  }, [isMobile, isShowFullList]);
  if (!attributes.length) return null;
  const isListTruncated = attributes.length > PRODUCT_ATTRIBUTES_ROW_SHOW_LIMIT;
  const visibleAttributes = isShowFullList || !isListTruncated ? attributes : attributes.slice(0, PRODUCT_ATTRIBUTES_ROW_SHOW_LIMIT);
  return <div data-test='pdp-product-attributes' className='mt-3 flex w-full flex-col gap-3 border-solid border-border-gray-light bg-surface-solid-0 max-lg:pt-4 lg:mt-4 lg:gap-3 lg:rounded lg:border lg:py-3 [&:nth-2]:border-t' data-sentry-component="ProductAttributes" data-sentry-source-file="product-attributes.tsx">
            <h2 className='text-right text-body-14 font-bold text-text-black lg:px-3 lg:text-body-16'>مشخصات</h2>

            <div className='relative'>
                <ProductAttributesTable attributes={visibleAttributes} data-sentry-element="ProductAttributesTable" data-sentry-source-file="product-attributes.tsx" />

                {!isShowFullList && isListTruncated && !isMobile && <div className='absolute bottom-0 right-0 h-1/3 w-full bg-gradient-to-t from-white' />}

                {isListTruncated && <Button graphicStyle={isMobile ? 'subtle' : 'text'} size='small' onClick={handleClick} icon={{
        element: <ShowMoreButtonIcon className='h-5 w-5 lg:h-6 lg:w-6' />,
        position: 'left'
      }} className={cn('text-sm max-lg:mx-auto max-lg:mt-2 lg:mr-auto', {
        'lg:absolute lg:-bottom-2 lg:left-0': !isShowFullList
      })}>
                        {showMoreButtonText}
                    </Button>}
            </div>
        </div>;
}
export default ProductAttributes;